<template>
    <div ref="list" class="card-houselist newcard" :data-loading="loading">
        <div class="title" v-if="isMlsNumberSearch">All matches of the MLS#{{title}}</div>
        <div class="title" v-else>Homes near {{title}}</div>
        <div class="card-houselist-items" >
             <a v-for="house in houseList" @click="navigate(house.dppUrl)" :data-light="house.light">
                <div class="img">
                    <img :src="house.tnImgPath">
                </div>
                <div class="flex vertical f5 small">
                    <div>
                       <b class="text-bold f4">{{$filters.formatFriendlyPrice(house.price)}}</b><span v-if="house.isRentals">/mo</span>
                    </div>
                    <div>
                        <b class="text-bold f4">{{house.bed || '—'}}</b> <span class="key text-gray">{{molang('search.card.Bd')}}</span>
                        <b class="text-bold f4">{{house.bath || '—'}}</b> <span class="key text-gray">{{molang('search.card.Ba')}}</span>
                       <template v-if="house.area"> <b class="text-bold f5">{{$filters.formatArea(house.area, house.isLand)}}</b> <span class="key text-gray">{{house.areaUnit}}</span></template>
                    </div>
                     <div class="address f7 text-gray" v-if="house.geo.address && house.geo.address.split('#').length===2">
                        Unit #{{house.geo.address.split('#')[1]}}
                    </div>
                    <div class="address f7 text-gray" v-else><span>{{house.geo.address}}</span></div>
                </div>
            </a>
        </div>
    </div>
</template>
<script src="./mvt-cardhouselist.js"></script>
<style lang="scss">
    @use './mvt-cardhouselist.scss' as *;
</style>
